<script setup lang="ts">
defineProps<{
  html: string
}>()
</script>

<template>
  <div v-shtml="html" class="html-modal-content" />
</template>

<style scoped>
.html-modal-content {
  font-size: 1rem;
  line-height: 1.6;
}
</style>
